import { Component, ViewChild } from '@angular/core';
import { Content } from 'ionic-angular';

import {datos} from '../../providers/datos';

declare var $:any ;
declare var window:any ;


@Component({
  selector: 'about',
  templateUrl: 'about.html'
})
export class about {
  
  @ViewChild(Content)
  content: Content;

  headerImage:any = "";
  active=false;
  color="transparente";
  showToolbar = true;

  pagina={
    headerTitle:"Acerca de ocre",
    title:"Ocre nails ©2018 Todos los Derechos Reservados",
    fondo:"assets/images/app/fondo.jpg",
    subtitle:"sub tirulo",
    items:[
      {
      title:"TITULO 1",
      subtitle:" Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam voluptatibus saepe odio omnis aspernatur laboriosam, laudantium earum repellat, tempora quo culpa voluptatum corrupti rem repudiandae necessitatibus dicta autem explicabo nam? "
    },
    {
      title:"TITULO 2",
      subtitle:" Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam voluptatibus saepe odio omnis aspernatur laboriosam, laudantium earum repellat, tempora quo culpa voluptatum corrupti rem repudiandae necessitatibus dicta autem explicabo nam? "
    },

    {
      title:"TITULO 3",
      subtitle:" Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam voluptatibus saepe odio omnis aspernatur laboriosam, laudantium earum repellat, tempora quo culpa voluptatum corrupti rem repudiandae necessitatibus dicta autem explicabo nam? "
    },

    {
      title:"TITULO 4",
      subtitle:" Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam voluptatibus saepe odio omnis aspernatur laboriosam, laudantium earum repellat, tempora quo culpa voluptatum corrupti rem repudiandae necessitatibus dicta autem explicabo nam? "
    },
    {
      title:"TITULO 4",
      subtitle:" Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam voluptatibus saepe odio omnis aspernatur laboriosam, laudantium earum repellat, tempora quo culpa voluptatum corrupti rem repudiandae necessitatibus dicta autem explicabo nam? "
    },  {
      title:"TITULO 4",
      subtitle:" Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam voluptatibus saepe odio omnis aspernatur laboriosam, laudantium earum repellat, tempora quo culpa voluptatum corrupti rem repudiandae necessitatibus dicta autem explicabo nam? "
    },  {
      title:"TITULO 4",
      subtitle:" Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam voluptatibus saepe odio omnis aspernatur laboriosam, laudantium earum repellat, tempora quo culpa voluptatum corrupti rem repudiandae necessitatibus dicta autem explicabo nam? "
    }
    ]

  }
  constructor(public datos:datos) {

  this.iniciar();
  }


 
fb(){

}
openUrl(url){
  
    window.location.href = url;

}

  isClassActive() {
    return this.active;
  }


  iniciar()
  {
    this.datos.getPagina('datos/about.json')
               .subscribe((data) => {
                   this.pagina = data;
                },
               (error: any) => {
                   console.log(error);
               });
               return this.pagina
  }



  subscribeToIonScroll() {
    console.log("screoll");

    if (this.content != null && this.content.ionScroll != null) {
      this.content.ionScroll.subscribe((d) => {
        console.log(d.scrollTop);
        if (d.scrollTop > 200 && this.active== false ) {
        console.log("cambio");
        this.active=true;
        $( "#est" ).trigger( "click" );
      }

      if (d.scrollTop < 200 && this.active== true ) {
      console.log("cambio");
      this.active=false;
      $( "#est" ).trigger( "click" );
    }


      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/about/about.ts